module.exports = __webpack_public_path__ + "static/media/books.f4c255df.png";